export enum EngineModes {
    MANUAL = 'MANUAL',
    AUTOFILL = 'AUTOFILL',
    PREVIOUS_AUTOMATIC_FILL = ' PREVIOUS_AUTOMATIC_FILL',
    COPY_FROM_OTHER_REPORT = 'COPY_FROM_OTHER_REPORT',
}
